"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeWorldMenus = void 0;
const WorldMenu_1 = require("../../classes/WorldMenu");
const definables_1 = require("definables");
const closeWorldMenus = () => {
    (0, definables_1.getDefinables)(WorldMenu_1.WorldMenu).forEach((worldMenu) => {
        if (worldMenu.isOpen()) {
            worldMenu.close();
        }
    });
};
exports.closeWorldMenus = closeWorldMenus;
